<template>
  <div>
    <div @click="file_export_dialog = true">
      <slot name="button">
      Import file
      </slot>
    </div>
    <v-dialog v-model="file_export_dialog" :max-width="max_dialog_width">
      <v-card style="border-radius: 8px; display: flex; flex-wrap: wrap; justify-content: center" elevation="0">
      <v-card-title>
        {{ $i18n.t('pages.vehicles_lists.data_export.title') }}
      </v-card-title>
      <v-card-text style="display: flex; flex-wrap: wrap; justify-content: center">
        <div v-if="this.page !== 'RecognitionJournal'">
          <v-checkbox
            v-for="list_name in lists_to_export" v-bind:key="list_name"
            multiple
            style="margin: 0 10px 0 0;"
            color="#207EA9"
            :label="$i18n.t(`pages.vehicles_lists.data_export.${list_name}`)"
            :value="list_name"
            v-model="export_info.lists"
          />
        </div>
        <div v-if="export_info.lists.includes('recognition_journal')">
          <v-subheader class="subheader margin-t">{{ $i18n.t('pages.vehicles_lists.data_export.start_date_of_period') }}</v-subheader>
          <date-picker
              :formatted_date="formatted_start_date"
              :placeholder="$i18n.t('pages.vehicles_lists.dialog.date')"
              @input_date="(params) => {this.journal_start_date = params.date}"
          />
          <v-subheader class="subheader margin-t">{{ $i18n.t('pages.vehicles_lists.data_export.end_date_of_period') }}</v-subheader>
          <date-picker
              :formatted_date="formatted_expiration_date"
              :placeholder="$i18n.t('pages.vehicles_lists.dialog.date')"
              @input_date="(params) => {this.journal_end_date = params.date}"
          />
        </div>

        <div style="padding-top: 30px; display: flex; justify-content: center; width: 100%">
          <v-btn
              class="white--text"
              color="#207ea9"
              style="width: 100%"
              height="42"
              elevation="0"
              @click="initial_export()"
          >
            <span class="button-font">
              {{ $i18n.t('pages.vehicles_lists.data_export.title') }}
            </span>
          </v-btn>
        </div>
        <!--
        <v-btn @click="initial_export()">
            {{ $i18n.t('pages.vehicles_lists.data_export.title') }}
        </v-btn>
        -->
      </v-card-text>
    </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import DatePicker from "@/custom_components/DatePicker";
import {common_funcs} from "@/mixins/common";

import moment from 'moment'
import 'moment-timezone'
import {i18n} from "@/i18n";
import store from "@/store";

export default {
  name: "FileExport",
    components: {DatePicker},
  mixins: [common_funcs],
  props: ['page'],
  data: function () {
    return {
      current_page: this.page,
      file_export_dialog: false,
      max_dialog_width: '300px',
      lists_to_export: ['whitelist', 'blacklist', 'recognition_journal'],
      journal_start_date: '',
      journal_end_date: '',
      export_info: {
        lists: [],
        start_date_of_period: '',
        end_date_of_period: ''
      }
    }
  },
  methods: {
    initial_export: function () {
      if (this.export_info.lists.length === 0) {
        this.setSnackbar({
          text: i18n.t('notifications.vehicles_lists.no_list_selected')
        })
        return
      }
      if (this.export_info.lists.includes('recognition_journal')) {
        this.export_info.start_date_of_period = this.picker_date_to_json(this.journal_start_date)
        this.export_info.end_date_of_period = this.picker_date_to_json(this.journal_end_date)
        console.log(this.export_info.start_date_of_period)
        console.log(this.export_info.end_date_of_period)
        console.log(this.journal_start_date)
        if (this.journal_start_date === this.journal_end_date) {
          this.export_info.start_date_of_period["$date"] = this.journal_start_date + "T" + "00:00:00Z"
          this.export_info.end_date_of_period["$date"] = this.journal_start_date + "T" + "23:59:59Z"
        }
        console.log(this.export_info.start_date_of_period)
        console.log(this.export_info.end_date_of_period)
      }
      let data = {export_info: this.export_info}
      this.updateLoadingOverlay({is_loading: true})
      this.$http({url: this.$http_hostname + '/vehicles_lists/export', data: data, method: 'POST'})
      .then(resp => {
        this.download_generated_file(resp.data.link)
        this.updateLoadingOverlay({is_loading: false})
      })
      .catch(error => {
        this.show_error_message(error)
        this.updateLoadingOverlay({is_loading: false})
      })
    },
    check_dates: function(){
      console.log(this.export_info.end_date_of_period)
      // if (this.export_info.start_date_of_period === this.export_info.end_date_of_period)
    },
    picker_date_to_json: function (date) {
        date = this.picker_date_to_dateobj(date)
        if (!date) return null
        let dt = moment(date).tz(this.$store.state.current_system_timezone, true).utc().format()
        return {'$date': dt}
    },
    picker_date_to_dateobj: function (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      date = new Date(year, month-1, day)
      return date
    },
    download_generated_file: function (file_link) {
      window.open(this.$http_hostname + file_link, '_blank')
    },
    picker_date_to_slash_date: function (date_from_picker) {
        if (!date_from_picker) return ''
        const [year, month, day] = date_from_picker.split('-')
        return `${day}/${month}/${year}`
    },

    dateobj_to_picker_date: function (datetime_obj) {
        let datetime_in_server_tz = moment.tz(datetime_obj, store.state.current_system_timezone)
        return datetime_in_server_tz.clone().startOf('day').format('YYYY-MM-DD');
    },
    ...mapActions(['setSnackbar', 'updateLoadingOverlay'])
  },
  computed: {
    formatted_start_date: function () {
      if (!this.journal_start_date) {
        console.log(parseInt(this.systemParams.journal_data_storage_period))
        return this.picker_date_to_slash_date(
            this.dateobj_to_picker_date(moment(this.systemDatetime).subtract(parseInt(this.systemParams.journal_data_storage_period), 'days').format('YYYY-MM-DD'))
        )
      }
      return this.picker_date_to_slash_date(this.journal_start_date)
    },
    formatted_expiration_date: function () {
      if (!this.journal_start_date) {
        return this.picker_date_to_slash_date(
            this.dateobj_to_picker_date(moment(this.systemDatetime).format('YYYY-MM-DD'))
        )
      }
      return this.picker_date_to_slash_date(this.journal_end_date)
    },
    ...mapGetters(['loadingOverlay', "systemParams", "systemDatetime"])

  },
  created(){
      if (this.page === 'RecognitionJournal'){
        this.lists_to_export = ['recognition_journal']
        this.export_info.lists = ['recognition_journal']
      }
      else{
        this.lists_to_export = ['whitelist', 'blacklist']
      }
  }
}
</script>

<style scoped>

</style>